import { Grid, Tooltip, Radio } from "@mui/material";
import InfoIcon from "../../../../../asset/image/info-icon.svg";
import "./SectionTitleWithHr.css";

interface SectionTitleWithHrProps {
  title: string;
  infoKey?: string;  
  showRadio?: boolean;  
  isSelected?: boolean;  
  onRadioChange?: () => void;  
  disabled?: boolean;
  showHoverMessage?: boolean;
  hoverMessage?: string;
}

const SectionTitleWithHr = ({
  title,
  infoKey,
  showRadio = false,
  isSelected = false,
  onRadioChange,
  disabled,
  showHoverMessage,
  hoverMessage
}: SectionTitleWithHrProps) => {
  return (
    <Grid container alignItems="center" className="section-header">
      <Grid item className="section-title" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {showRadio && (
          <Tooltip title={hoverMessage || ''} disableHoverListener={!showHoverMessage}>
            <Radio
              checked={isSelected}
              onChange={onRadioChange}
              size="small"
              sx={{
                padding: 0,
                color: '#244C84',  
                '&.Mui-checked': {
                  color: '#244C84',  
                },
              }}
              disabled={disabled ? true : false}
            />
          </Tooltip>
        )}
        <span>{title}</span>
        {infoKey && (
          <Tooltip title={infoKey}>
            <img src={InfoIcon} alt="info" className="info-icon" />
          </Tooltip>
        )}
      </Grid>
      <Grid item xs className="section-divider" />
    </Grid>
  );
};

export default SectionTitleWithHr;
